import Index from "./Index.vue";
import New from "./New.vue";
import Show from "./Show.vue";
import Edit from "./Edit.vue";

export default [
  {
    path: "",
    name: "UsersSystemAdminTrainingsIndex",
    component: Index,
    meta: {
      title: "研修管理",
      subtitle: "TRAINING",
      tree: [
        {
          name: "UsersManagementIndex",
          title: "管理者メニュー",
        },
      ],
    },
  },
  {
    path: "new",
    name: "UsersSystemAdminTrainingsNew",
    component: New,
    meta: {
      title: "新規作成",
      tree: [
        {
          name: "UsersManagementIndex",
          title: "管理者メニュー",
        },
        {
          name: "UsersSystemAdminTrainingsIndex",
          title: "研修管理",
        },
      ],
    },
  },
  {
    path: "show/:id",
    name: "UsersSystemAdminTrainingsShow",
    component: Show,
    meta: {
      title: "詳細",
      tree: [
        {
          name: "UsersManagementIndex",
          title: "管理者メニュー",
        },
        {
          name: "UsersSystemAdminTrainingsIndex",
          title: "研修管理",
        },
      ],
    },
  },
  {
    path: "edit/:id",
    name: "UsersSystemAdminTrainingsEdit",
    component: Edit,
    meta: {
      title: "編集",
      tree: [
        {
          name: "UsersManagementIndex",
          title: "管理者メニュー",
        },
        {
          name: "UsersSystemAdminTrainingsIndex",
          title: "研修管理",
        },
      ],
    },
  },
];
